import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/** Grandma Lee's old house: terrazzo floor, a little kitchen, the tea table and her treasures. */
const b = new MapBuilder(14, 11, ' ');
b.room(0, 0, 14, 11, 'z');
b.fill(1, 1, 4, 2, 'k');
b.fill(6, 10, 2, 1, 'D');

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });
const box = (tx: number, ty: number, tw: number, h = 10): Decor['solid'] => ({ x: px(tx) + 1, y: px(ty) - h, w: px(tw) - 2, h });

const decor: Decor[] = [
  { kind: 'window', x: px(9), y: 0, w: px(2), wall: true },
  { kind: 'painting', x: px(12), y: 3, wall: true, variant: 1 },
  { kind: 'kitchenCounter', ...at(2, 3), w: px(3), solid: box(1, 3, 3, 10) },
  { kind: 'altar', ...at(7, 2), w: px(3), solid: box(5.5, 2, 3, 10) },
  { kind: 'woodChair', ...at(5, 7), variant: 0 },
  { kind: 'woodChair', ...at(9, 7), variant: 1 },
  { kind: 'fanStand', ...at(2, 8) },
  { kind: 'catBasket', ...at(12, 9) },
  { kind: 'pottedPlant', x: px(1) + 8, y: px(9) + 12, solid: { x: px(1) + 2, y: px(9) + 6, w: 12, h: 6 } },
];

export const grandma: MapDef = {
  id: 'grandma',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#e8dcc0', wallLight: '#f4ead2', wainscot: '#7a5236', wallTop: '#33241a' },
  doors: [{ tiles: [[6, 10], [7, 10]], to: 'town', arrive: { x: px(8) + 8, y: px(55), facing: 'down' } }],
  decor,
  areas: [{ key: 'grandma', rect: { x: 0, y: 0, w: px(14), h: px(11) } }],
  lights: [
    { x: px(7), y: px(6), r: 100, color: '255,206,140' },
    { x: px(7), y: px(2), r: 60, color: '255,120,90' },
    { x: px(3), y: px(3), r: 60, color: '255,230,180' },
  ],
};
